if (!customElements.get('mf-hero-carousel')) {
  class MeubelfritsHero extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      this.timer = null;
      this.prefetchTimer = null;
      this.pageLoaded = document.readyState === 'complete';
      this.paused = this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.pauseButton = this.querySelector('[data-pause]');
      if (this.slides.length < 2) return;
      this.setAttribute('data-enhanced', 'true');
      this.querySelector('.mf-hero__controls').hidden = false;
      this.querySelector('[data-next]').addEventListener('click', () => { this.stopForUser(); this.show(this.index + 1); });
      this.querySelector('[data-previous]').addEventListener('click', () => { this.stopForUser(); this.show(this.index - 1); });
      this.dots.forEach(dot => dot.addEventListener('click', () => { this.stopForUser(); this.show(Number(dot.dataset.dot)); }));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.start(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); });
      this.addEventListener('focusin', event => { if (event.target !== this.pauseButton) this.stopForUser(); });
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.stopForUser(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      this.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') this.touchX = event.clientX; });
      this.addEventListener('pointerup', event => {
        if (event.pointerType === 'touch' && typeof this.touchX === 'number') {
          const delta = event.clientX - this.touchX;
          if (Math.abs(delta) > 60) { this.stopForUser(); this.show(this.index + (delta < 0 ? 1 : -1)); }
          this.touchX = undefined;
        }
      });
      this.visibilityHandler = () => { if (document.hidden) this.stop(); else this.start(); };
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.blockHandler = event => {
        const target = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (target !== -1) { this.stopForUser(); this.show(target); }
      };
      document.addEventListener('shopify:block:select', this.blockHandler);
      this.loadHandler = () => {
        this.pageLoaded = true;
        this.prepareNext();
        this.start();
      };
      if (!this.pageLoaded) window.addEventListener('load', this.loadHandler, { once: true });
      this.updatePause();
      this.show(0);
      this.start();
    }
    disconnectedCallback() {
      this.stop();
      window.clearTimeout(this.prefetchTimer);
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      document.removeEventListener('shopify:block:select', this.blockHandler);
      window.removeEventListener('load', this.loadHandler);
    }
    show(next) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', String(!active));
        if (active) {
          this.hydrate(slide);
          slide.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        }
      });
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      if (this.pageLoaded) this.prepareNext();
    }
    hydrate(slide) {
      const template = slide.querySelector('template[data-slide-image]');
      if (!template) return;
      template.parentNode.insertBefore(template.content.cloneNode(true), template);
      template.remove();
    }
    prepareNext() {
      window.clearTimeout(this.prefetchTimer);
      this.prefetchTimer = window.setTimeout(() => {
        if (!this.isConnected || document.hidden || this.paused) return;
        const next = this.slides[(this.index + 1) % this.slides.length];
        this.hydrate(next);
        next.querySelectorAll('img').forEach(img => {
          img.fetchPriority = 'low';
          img.loading = 'eager';
        });
      }, 1800);
    }
    stop() { window.clearInterval(this.timer); this.timer = null; }
    start() {
      this.stop();
      if (this.pageLoaded && !this.paused && !this.hovered && !document.hidden) this.timer = window.setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 2000);
    }
    updatePause() {
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
      this.pauseButton.querySelector('[data-pause-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
    }
    stopForUser() { this.paused = true; this.stop(); this.updatePause(); }
  }
  customElements.define('mf-hero-carousel', MeubelfritsHero);
}


